interface StatusPillProps {
  status: string;
  variant?: 'green' | 'amber' | 'red' | 'blue' | 'navy' | 'auto';
}

const PILL_LABELS: Record<string, { label: string; variant: 'green' | 'amber' | 'red' | 'blue' | 'navy' }> = {
  // Beneficiary stages
  application:      { label: 'Application',     variant: 'blue' },
  lottery_selected: { label: 'Lottery selected', variant: 'navy' },
  declaration:      { label: 'Declaration',     variant: 'navy' },
  deposit_verified: { label: 'Deposit verified', variant: 'amber' },
  subsidy_released: { label: 'Subsidy released', variant: 'amber' },
  verified:         { label: 'Verified',        variant: 'green' },
  rejected:         { label: 'Rejected',        variant: 'red' },
  // Poultry stages
  cvo_review:       { label: 'CVO Review',      variant: 'blue' },
  pre_appraisal:    { label: 'Pre-Appraisal',   variant: 'blue' },
  appraisal:        { label: 'Appraisal',       variant: 'amber' },
  final_approval:   { label: 'Final Approval',  variant: 'navy' },
  approved:         { label: 'Approved',        variant: 'green' },
  // Camp status
  scheduled:        { label: 'Scheduled',       variant: 'blue' },
  in_progress:      { label: 'In Progress',     variant: 'amber' },
  completed:        { label: 'Completed',       variant: 'green' },
  cancelled:        { label: 'Cancelled',       variant: 'red' },
  // Severity
  critical:         { label: 'Critical',        variant: 'red' },
  warning:          { label: 'Warning',         variant: 'amber' },
  info:             { label: 'Info',            variant: 'blue' },
  // Generic
  open:             { label: 'Open',            variant: 'amber' },
  acknowledged:     { label: 'Acknowledged',    variant: 'blue' },
  resolved:         { label: 'Resolved',        variant: 'green' },
  accepted:         { label: 'Accepted',        variant: 'green' },
  active:           { label: 'Active',          variant: 'green' },
  inactive:         { label: 'Inactive',        variant: 'red' },
};

export function StatusPill({ status, variant }: StatusPillProps) {
  const meta = PILL_LABELS[status] ?? { label: status, variant: (variant && variant !== 'auto' ? variant : 'navy') as 'navy' };
  return <span className={`pill pill-${meta.variant}`}>{meta.label}</span>;
}
